import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, UserWithCredentials } from '@deckplan.io/common/users';
import { Pagination, Query } from '@deckplan.io/common';
import { map } from 'rxjs/operators';
import { UrlUtils } from '../common/utils/url-utils';
import { Mockable } from '../mocks/mockable.decorator';

export interface UsersAndTotalCount {
    totalCount: number;
    users: User[];
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class UsersService {

    private readonly backendUrl = UrlUtils.constructBackendUrl('users');

    constructor(private readonly http: HttpClient) {}

    public getAll(pagination: Partial<Pagination> = null, query: Query = null): Observable<UsersAndTotalCount> {
        const url = UrlUtils.constructPaginationAndFilterUrl(this.backendUrl, pagination, query);

        return this.http.get(url, {observe: 'response'})
            .pipe(
                map(res => ({totalCount: parseInt(res.headers.get('total-count'), 10), users: res.body as any}))
            );
    }

    public getOne(id: number): Observable<User> {
        return this.http.get<User>(`${this.backendUrl}/${id}`);
    }

    public create(user: UserWithCredentials): Observable<User> {
        return this.http.post<User>(`${this.backendUrl}`, user);
    }

    public update(id: number, updates: any): Observable<User> {
        return this.http.put<User>(`${this.backendUrl}/${id}`, updates);
    }

    public delete(id: number): Observable<User> {
        return this.http.delete<User>(`${this.backendUrl}/${id}`);
    }

}
